// extracted by mini-css-extract-plugin
module.exports = {"header":"TheHeader_header_25DqM","primaryHeader":"TheHeader_primaryHeader_1o341","subHeader":"TheHeader_subHeader_24mi_"};